// TTG PDP availability guard 2026-06-11
// Narrow safety shim: if Shopify selected-variant JSON says the selected variant is available,
// clear stale Dawn disabled/sold-out state so the real product form can submit normally.
(() => {
  const MARKER = 'TTG PDP availability guard 2026-06-11';

  function parseSelectedVariant(scope) {
    const text = scope?.querySelector('variant-selects [data-selected-variant]')?.textContent;
    if (!text) return null;
    try { return JSON.parse(text); } catch (_) { return null; }
  }

  function syncForm(productForm) {
    const info = productForm.closest('product-info') || document;
    const variant = parseSelectedVariant(info);
    const form = productForm.querySelector('form');
    const input = form?.querySelector('input[name="id"]');
    const button = productForm.querySelector('[type="submit"]');
    const text = button?.querySelector('span');
    if (!variant || !variant.available || !input || !button) return;
    if (String(input.value) && String(input.value) !== String(variant.id)) return;

    input.value = String(variant.id);
    input.removeAttribute('disabled');
    button.removeAttribute('disabled');
    button.removeAttribute('aria-disabled');
    button.classList.remove('loading');
    productForm.querySelector('.loading__spinner')?.classList.add('hidden');
    productForm.querySelector('.sold-out-message')?.classList.add('hidden');
    if (text) {
      text.classList.remove('hidden');
      text.textContent = window.variantStrings?.addToCart || 'Add to wardrobe bag';
    }
  }

  function syncAll() {
    document.querySelectorAll('product-form').forEach(syncForm);
  }

  document.addEventListener('DOMContentLoaded', syncAll);
  document.addEventListener('product-info:loaded', syncAll, true);
  document.addEventListener('change', () => window.setTimeout(syncAll, 0), true);
  window.addEventListener('pageshow', syncAll);

  const observer = new MutationObserver(() => window.requestAnimationFrame(syncAll));
  observer.observe(document.documentElement, { childList: true, subtree: true });

  window.TTG_PDP_AVAILABILITY_GUARD = { marker: MARKER, syncAll };
})();
